import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import ScrollContainer from './ScrollContainer';
import { taskValidationSchema } from '../utils/util';
import Actions from '../actions';

import TaskForm from './TaskForm';

const data = {
  insertOrUpdate: {},
  delete: [],
};

const PLANS = ['default', 'plan_1'];

function Days(props) {
  const {
    getPlanDays,
    plan,
    fetchingData,
    fetchingDays,
    fetchingDay,
    taskDays,
    fetchSingleDayTasks,
    tasks,
    learnExercises,
    videoTypeExercises,
    videoUrlTypeExercises,
    taskTemplates,
    practiceExercises,
    quizes,
    assessments,
  } = props;
  const days = taskDays && taskDays.days;
  const [daysTasks, setDaysTasks] = React.useState([]);
  const planId = plan && plan._id;

  const [copyDay, setCopyDay] = React.useState(undefined);

  React.useEffect(() => {
    if (planId) getPlanDays({ planId });
  }, [getPlanDays, planId]);

  React.useEffect(() => {
    if (days) {
      const undefinedArray = new Array(days).fill(undefined);
      setDaysTasks(undefinedArray);
    }
  }, [days]);

  const getTasks = (day, copy) => {
    if (daysTasks[day - 1]) {
      if (copy) setCopyDay(day);
    } else {
      const promise1 = practiceExercises ? Promise.resolve() : props.getPracticeExercises();
      const promise2 = learnExercises ? Promise.resolve() : props.getLearnExercises();
      const promise3 = quizes ? Promise.resolve() : props.getQuizes();
      const promise4 = assessments ? Promise.resolve() : props.getAssessments();
      const promise5 = taskTemplates ? Promise.resolve() : props.fetchTaskTemplates();
      const promise6 = fetchSingleDayTasks({ planId, day });
      const promise7 = videoTypeExercises ? Promise.resolve() : props.getVideoTypeExercises();
      const promise8 = videoUrlTypeExercises ? Promise.resolve() : props.getVideoUrlTypeExercises();
      Promise.all([promise1, promise2, promise3, promise4, promise5, promise6, promise7, promise8])
        .then(() => { if (copy) setCopyDay(day); });
    }
  };

  const collectData = (task) => {
    if (task && task.day && task.task) {
      const key = `${task.day}_${task.task}`;
      data.insertOrUpdate[key] = task;
    }
  };

  if ((tasks && tasks.day && !daysTasks[tasks.day - 1])) {
    const newArray = [...daysTasks];
    newArray[tasks.day - 1] = tasks.tasks;
    setDaysTasks([...newArray]);
  }

  const copy = (day) => {
    const dayTasks = daysTasks[day - 1];
    if (dayTasks && dayTasks.length > 0) {
      let lastDayIndex = daysTasks.length;
      lastDayIndex = (daysTasks[lastDayIndex - 1] && daysTasks[lastDayIndex - 1].length === 0) ? lastDayIndex - 1 : lastDayIndex;
      const newDayTasks = dayTasks.map((task, index) => {
        const key = `${day}_${index + 1}`;
        const newTask = { ...task, ...data.insertOrUpdate[key] };
        delete newTask._id;
        newTask.day = lastDayIndex + 1;
        collectData(newTask);
        return newTask;
      });
      const newDaysTasks = [...daysTasks];
      newDaysTasks[lastDayIndex] = newDayTasks;
      setDaysTasks(newDaysTasks);
    }
  };

  if (copyDay) {
    copy(copyDay);
    setCopyDay(undefined);
  }

  const addDay = () => {
    const taskNumber = daysTasks.length;
    if (taskNumber === 0 || (taskNumber > 0 && (daysTasks[taskNumber - 1] && daysTasks[taskNumber - 1].length) !== 0)) {
      setDaysTasks([...daysTasks, []]);
      getTasks(taskNumber + 1);
    }
    window.scrollTo({
      left: 0,
      top: document.documentElement.offsetHeight,
      behavior: 'auto',
    });
  };

  const addTask = (day) => {
    const newArray = [...daysTasks];
    if (newArray[day - 1]) newArray[day - 1].push(undefined);
    setDaysTasks(newArray);
  };

  const deleteTask = (day, task, id) => {
    if (id) {
      const key = `${task.day}_${task.task}`;
      data.delete.push(id);
      delete data.insertOrUpdate[key];
    }
    const newDaysTasks = [...daysTasks];
    const index = newDaysTasks[day - 1].findIndex((dayTask) => { return (dayTask && dayTask.task === task); });
    if (index > -1) {
      newDaysTasks[day - 1].splice(index, 1);
      setDaysTasks(newDaysTasks);
    }
  };

  const handleSubmit = () => {
    const insertOrUpdate = {};
    Object.values(data.insertOrUpdate).forEach((task) => {
      const key = `${task.day}_${task.task}`;
      if (!task._id) insertOrUpdate[key] = task;
      else {
        const index = daysTasks[task.day - 1] && daysTasks[task.day - 1].findIndex((dayTask) => { return (dayTask && dayTask.task === task.task); });
        const prevTask = daysTasks[task.day - 1] && daysTasks[task.day - 1][index];
        if (prevTask) {
          Object.keys(task).forEach((field) => {
            if (
              (prevTask[field] !== task[field] && Array.isArray(prevTask[field]) && JSON.stringify(prevTask[field]) !== JSON.stringify(task[field]))
              || (prevTask[field] !== task[field] && !Array.isArray(prevTask[field]))
            ) {
              insertOrUpdate[key] = task;
              return false;
            } return true;
          });
        }
      }
    });
    const taskPromises = Object.values(insertOrUpdate).map((task) => { return taskValidationSchema.validate(task); });
    Promise.all(taskPromises)
      .then((insertOrUpdateTasks) => {
        props.updateTasks({ insertOrUpdate: insertOrUpdateTasks, deleteTasks: data.delete, planId: plan._id })
          .then(() => {
            alert('Data inserted successfully');
            props.handleNext();
          });
      }).catch((err) => {
        err.errors.forEach((message) => { alert(`Day: ${err.value.day}, Task: ${err.value.task}  Error: ${message}`); });
      });
  };

  const syncTasks = () => {
    return props.syncTasks()
      .then(() => { alert('Tasks synced successfully!'); })
      .catch((err) => {
        alert(`Error: ${err}`);
      });
  };

  return (
    <ScrollContainer>
      <div style={{ overflow: 'auto' }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15,
        }}
        >
          <div>
            <Fab style={{ background: '#583c5c', color: '#fff' }} onClick={() => { return addDay(); }} aria-label="add-day">
              <AddIcon />
            </Fab>
          </div>
          <div>
            <h3>
              {'Plan: '}
              {plan && plan.name}
              &nbsp;&nbsp;
              {' Days: '}
              {days}
              &nbsp;&nbsp;
              {
                PLANS.includes(plan && plan.name)
                  ? (
                    <Button variant="contained" style={{ marginTop: -5 }} onClick={syncTasks}>
                      Sync Tasks with
                      {' '}
                      { plan && plan.name === PLANS[0] ? PLANS[1] : PLANS[0] }
                    </Button>
                  )
                  : null
              }
            </h3>
          </div>
        </div>
        <div>
          {
              fetchingDays
                ? <CircularProgress disableShrink />
                : daysTasks.map((dayTask, index) => {
                  const day = index + 1;
                  return (
                  // eslint-disable-next-line react/no-array-index-key
                    <div key={index}>
                      <Paper style={{ marginBottom: 15 }}>
                        <div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                            <h2 style={{ textAlign: 'left', paddingLeft: 15 }}>{`Day ${day}`}</h2>
                            <div style={{ display: 'flex', alignContent: 'center', width: '90%' }}>
                              {
                                !dayTask
                                  ? (
                                    <Button
                                      variant="contained"
                                      style={{ width: '100%' }}
                                      onClick={() => { return getTasks(day); }}
                                    >
                                      {`Show Day ${day} Tasks`}
                                    </Button>
                                  )
                                  : null
                              }
                            </div>
                          </div>
                        </div>
                        {
                          // eslint-disable-next-line no-nested-ternary
                          fetchingData && fetchingDay === day
                            ? <CircularProgress disableShrink />
                            : dayTask && dayTask.length === 0
                              ? <p style={{ padding: 10 }}>No Tasks Found</p>
                              : dayTask && dayTask.map((task, taskIndex) => {
                                return (
                                  <div key={(task && task._id) || taskIndex}>
                                    <TaskForm
                                      taskData={task}
                                      plan={plan}
                                      learnExercises={learnExercises}
                                      videoTypeExercises={videoTypeExercises}
                                      videoUrlTypeExercises={videoUrlTypeExercises}
                                      taskTemplates={taskTemplates}
                                      task={(task && task.task) || (taskIndex + 1)}
                                      day={day}
                                      practiceExercises={practiceExercises}
                                      quizes={quizes}
                                      assessments={assessments}
                                      collectData={(newTask) => { return collectData(newTask); }}
                                      deleteTask={(curDay, taskNumber, _id) => { return deleteTask(curDay, taskNumber, _id); }}
                                      showDelete={taskIndex === (dayTask.length - 1)}
                                    />
                                  </div>
                                );
                              })
                        }
                        {
                          dayTask ? (
                            <div style={{ padding: 15 }}>
                              <Fab size="medium" color="secondary" onClick={() => { return addTask(day); }} aria-label="add-task">
                                <AddIcon />
                              </Fab>
                            </div>
                          ) : null
                        }
                      </Paper>

                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 15 }}>
                        <Button variant="contained" onClick={() => { return getTasks(day, true); }}>
                          Copy Day
                          {' '}
                          {day}
                        </Button>
                      </div>

                    </div>
                  );
                })
            }
          <div style={{ display: 'flex', justifyContent: 'start' }}>
            <Fab style={{ background: '#583c5c', color: '#fff' }} onClick={() => { return addDay(); }} aria-label="add-day">
              <AddIcon />
            </Fab>
          </div>
          <div style={{ margin: 50 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => { return handleSubmit(); }}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </ScrollContainer>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    quizes: state.quizes.data,
    assessments: state.assessments.data,
    taskTemplates: state.taskTemplate.data,
    learnExercises: state.learnExercises.data,
    videoTypeExercises: state.videoExercises.videoTypes,
    videoUrlTypeExercises: state.videoExercises.videoUrlTypes,
    practiceExercises: state.practiceExercises.data,
    taskDays: state.days.data,
    tasks: state.tasks.dayTasks,
    fetchingDays: state.days.fetching,
    fetchingDay: state.tasks.day,
    fetchingData: state.quizes.fetching
            || state.assessments.fetching
            || state.taskTemplate.fetching
            || state.learnExercises.fetching
            || state.practiceExercises.fetching
            || state.tasks.fetching
            || state.videoExercises.fetching,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Days));
